<div class="color-pill">
  <span class="value">{{ value }}</span>
</div>
